import ApiService from "../../../common/api.service";

export async function GetOrderDisplays({ commit }, option) {
  try {
    ApiService.init();
    commit("ORDER_DISPLAY_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/orderdisplay", option);
    commit("ORDER_DISPLAY_SUCCESS", _response);
  } catch (error) {
    commit("ORDER_DISPLAY_ERROR", { result: error.message });
  }
}
